import { connect } from 'react-redux';

import { openFreeTrialModal } from 'actions/modals';

import {
  getIsDirectMailReturningUser,
  getOnboardingTrialSourceIsDirectMail,
} from 'selectors/onboarding';
import { getOnboardingTrialSource } from 'selectors/session';

import FirstLandModal from './FirstLandModal';

export default connect(
  state => ({
    isDirectMailReturningUser: getIsDirectMailReturningUser(state),
    isDirectMailUser: getOnboardingTrialSourceIsDirectMail(state),
    onboardingTrialSource: getOnboardingTrialSource(state),
  }),
  {
    openFreeTrialFirstLandModal: openFreeTrialModal,
  }
)(FirstLandModal);
